import { INITIAL_FIELD_STATE } from "./app.constants";

export const VALIDATION_MSGS = {
    REQUIRED: "Please enter a value here"
}

export const CONTACT_US_INITIAL_STATE = {
    emailAddress: {...INITIAL_FIELD_STATE, errors: []},
    subject: {...INITIAL_FIELD_STATE, errors: [VALIDATION_MSGS.REQUIRED]},
    message: {...INITIAL_FIELD_STATE, errors: [VALIDATION_MSGS.REQUIRED]},
    showSuccessMessage: {value: false, errors: []}, 
    errorMessage: {value:"", errors:[] }
}

export const CONTACT_US_VALIDATION = {
    EMAIL_MESSAGE: /^([A-Za-z0-9.'@!#$%^&*(),/?|\;:'" ])*$/ ,
  };

  export const CONTACT_US_VALIDATION_MSGS = {
    INVALID_EMAIL_BODY: "Please enter valid value. It may only contain letters,numbers, spaces, and special character (!@#$%^&*(),.\'\";:)",
  }


